export default __webpack_public_path__ + "static/media/alexandru-acea--WBYxmW4yuw-unsplash-min.d516921b.jpg";